/***********************
 * INDEX TAB2 CONTENT
 * (ALARMS)
 ************************/

import React, { useState } from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"

// Locale
import { withTranslation } from "react-i18next"

// Alarms components
import AlertsTable from "./AlertsTable"
import AlertsChart from "./AlertsChart"
import CardTableBtn from "../CardTableBtn"

const AlertsReporting = props => {
  const [widgetVisible, setWidgetVisible] = useState(true)
  const [tableVisible, setTableVisible] = useState(false)

  return (
    <>
      <Row>
        <Col>
          <CardTableBtn
            widgetVisible={widgetVisible}
            tableVisible={tableVisible}
            setWidgetVisible={setWidgetVisible}
            setTableVisible={setTableVisible}
          ></CardTableBtn>
          <div className="mt-2 mb-1">
            {widgetVisible && (
              <div>
                <AlertsChart
                  customers={props.customers}
                  data={props.data}
                  start={props.start}
                  end={props.end}
                  quickGuide={props.quickGuide}
                />
              </div>
            )}
            {tableVisible && <AlertsTable minRows={0} data={props.data} />}
          </div>
        </Col>
      </Row>
    </>
  )
}

AlertsReporting.propTypes = {
  data: PropTypes.any,
  customers: PropTypes.any,
  start: PropTypes.any,
  end: PropTypes.any,
  quickGuide: PropTypes.any,
}

export default withTranslation()(AlertsReporting)
